<template>
  <div class="opponent-leaderboard">
    <img class="header-image" :src="opponent.image5">
    <div class="my-highscore" v-if="myHighscore">
      <ScoreRow
        :rank="myHighscore.index + 1"
        :name="myHighscore.name"
        :surname="myHighscore.surname"
        :score="myHighscore.score"
        body-background-color="var(--color-black-4)"
        rank-background-color="var(--color-gold-1)"
      />
    </div>
    <div class="highscores">
      <ScoreRow
        v-for="(item, i) in highscores"
        :key="i"
        :rank="i + 1"
        :name="item.name"
        :surname="item.surname"
        :score="item.score"
        :body-background-color="i % 2 === 0 ? 'var(--color-gray-7)' : 'var(--color-gray-2)'"
        :rank-background-color="i % 2 === 0 ? 'var(--color-white-1)' : 'var(--color-gray-6)'"
      />
    </div>
  </div>
</template>

<script>
import ScoreRow from './partials/ScoreRow/ScoreRow'
import LeaderboardService from '@/services/LeaderboardService'
import { opponentsById } from '@/data/opponents'
import { mapState } from 'vuex'
export default {
  components: {
    ScoreRow
  },
  props: {
    opponentId: {
      type: String,
      required: true
    }
  },
  data: () => ({
    myHighscore: null,
    highscores: []
  }),
  computed: {
    ...mapState('user', {
      userId: state => state.userProfile._id
    }),
    opponent () {
      return opponentsById[this.opponentId]
    }
  },
  methods: {
    async fetchData () {
      if (this.myHighscore && this.highscores.length) return
      [this.myHighscore, this.highscores] = await Promise.all([
        this.userId && LeaderboardService.getMyHighscore({ userId: this.userId, opponentId: this.opponentId }),
        LeaderboardService.getAllHighscores({ opponentId: this.opponentId, limit: 100 })
      ])
    }
  }
}
</script>

<style lang="scss" scoped>
.opponent-leaderboard {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.header-image {
  width: 100%;
  height: auto;
  display: block;
  margin-top: calc(-1 * var(--spacing-2));
}
.highscores {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
</style>
